export default __webpack_public_path__ + "static/media/building.99d860b3.jpg";